export default {
  getDocumentWidth: function () {
    const width = window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    return width
  },
  getDocumentHeight: function () {
    const height = window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
    return height
  }
}



// WEBPACK FOOTER //
// ./src/Utils.js